import { useState } from 'react';

const useToggleState = (
  initialState = false
): [boolean, () => void, () => void] => {
  const [state, setState] = useState(initialState);

  const toggleState = () => {
    setState((prev) => !prev);
  };

  const open = () => {
    setState(true);
  };

  return [state, toggleState, open];
};

export default useToggleState;
